import { APPEARANCE } from '../../constants';
export var Variant;
(function (Variant) {
    Variant["LabelOnly"] = "label-only";
    Variant["IconOnly"] = "icon-only";
    Variant["IconBefore"] = "icon-before";
    Variant["IconAfter"] = "icon-after";
})(Variant || (Variant = {}));
export const APPEARANCE_TO_COLOR_MAP = {
    [APPEARANCE.Neutral]: 'neutral',
    [APPEARANCE.Primary]: 'primary',
    [APPEARANCE.Destructive]: 'red',
};
